function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m697 321 118 176.322h-31l-116-176.322z",
  fill: "#007e6f",
  fillRule: "evenodd",
  transform: "translate(-618 -321)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 120.5,
  cy: 89.5,
  fill: "#ce1836",
  r: 71.5
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  transform: "translate(-618 -321)"
}, React.createElement("path", {
  d: "m803 354.881h29l-91 108.119-12-19z",
  fill: "#018a7c"
}), React.createElement("path", {
  d: "m856.7 496.881v-175.616h-22.786v126.72l1.536 48.9h21.25z",
  fill: "#009989"
}), React.createElement("path", {
  d: "m748.7 496.881v-175.616h-22.786v126.72l-.768.256-84.992-126.976h-22.016v175.616h22.784v-128.256l.768-.256 85.76 128.512z",
  fill: "#009989"
}), React.createElement("path", {
  d: "m748 321 109.091 163.011c-.078.675-.091 12.989-.091 12.989l-22 .322-108.381-164.742c.124.392-.619-11.58-.619-11.58z",
  fill: "#01c8b4"
}), React.createElement("path", {
  d: "m640 321 109.091 163.011c-.078.675-.091 12.989-.091 12.989l-22 .322-108.381-164.742c.124.392-.619-11.58-.619-11.58z",
  fill: "#01c8b4"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 176,
    viewBox: "0 0 240 176",
    width: 240,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.b2511e58.svg";
export { ForwardRef as ReactComponent };